import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IpProfileApiService} from '../../services/api/network/online/ip-profile/ip-profile-api.service';

@Injectable()
export class IpProfilesResolver implements Resolve<any> {
  constructor(private ipProfileApiService: IpProfileApiService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.ipProfileApiService.getIpProfilesDefinitionEnum();
  }

}
